(() => {
  const STORAGE_KEY = 'perendi_popspin_surprise_gift';
  const MARKER = '🎁 ÇARK-SÜRPRİZ-HEDİYE';
  const NOTE = `${MARKER} — 1.500 TL ve üzeri siparişte sürpriz hediye ekle`;
  const REWARD_HEADING = /Sürpriz hediyeni kazandın/i;
  const ANY_REWARD_HEADING = /kazandın/i;
  const TWO_HOURS = 2 * 60 * 60 * 1000;
  let marking = false;
  let observedRoot = null;
  let countdownTimer = null;

  const readState = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (_) {
      return null;
    }
  };

  const writeState = (state) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_) {}
  };

  const clearState = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  };

  const formatRemaining = (milliseconds) => {
    const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const findRewardElement = (root) => {
    const candidates = root.querySelectorAll('h1, h2, h3, h4, p, span, div');
    return Array.from(candidates).find((element) => {
      const text = (element.textContent || '').trim();
      return ANY_REWARD_HEADING.test(text) && element.children.length <= 2;
    });
  };

  const renderCountdown = (root) => {
    const state = readState();
    if (!state?.expiresAt) return;

    let countdown = root.querySelector('#perendi-popspin-countdown');
    if (!countdown) {
      countdown = document.createElement('div');
      countdown.id = 'perendi-popspin-countdown';
      countdown.style.cssText = [
        'margin:12px auto 4px',
        'padding:10px 14px',
        'max-width:320px',
        'border-radius:10px',
        'background:#fff3cd',
        'color:#7a3e00',
        'font-size:14px',
        'font-weight:700',
        'line-height:1.35',
        'text-align:center',
        'box-sizing:border-box',
      ].join(';');
      const rewardElement = findRewardElement(root);
      if (rewardElement?.parentElement) rewardElement.parentElement.appendChild(countdown);
      else root.appendChild(countdown);
    }

    const update = () => {
      const current = readState();
      const remaining = (current?.expiresAt || 0) - Date.now();
      if (remaining <= 0) {
        countdown.textContent = 'İndirim hakkının süresi doldu.';
        if (countdownTimer) clearInterval(countdownTimer);
        countdownTimer = null;
        return;
      }
      countdown.textContent = `İndirim hakkını ${formatRemaining(remaining)} içinde kullan.`;
    };

    update();
    if (countdownTimer) clearInterval(countdownTimer);
    countdownTimer = setInterval(update, 1000);
  };

  const activateRewardWindow = (root) => {
    const current = readState();
    if (!current?.expiresAt || current.expiresAt <= Date.now()) {
      writeState({ ...(current || {}), expiresAt: Date.now() + TWO_HOURS });
    }
    renderCountdown(root);
  };

  const getCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Cart could not be read');
    return response.json();
  };

  const updateCart = async (cart, active) => {
    const currentNote = typeof cart.note === 'string' ? cart.note : '';
    const lines = currentNote.split('\n').filter((line) => line.trim() && !line.includes(MARKER));
    if (active) lines.push(NOTE);

    const attributes = { ...(cart.attributes || {}) };
    attributes['Çark ödülü'] = active ? 'Sürpriz hediye ürün' : '';
    attributes['Hediye koşulu'] = active ? '1.500 TL ve üzeri' : '';

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note: lines.join('\n'), attributes }),
    });
    if (!response.ok) throw new Error('Cart could not be updated');
    return response.json();
  };

  const markSurpriseGift = async () => {
    if (marking) return;
    marking = true;
    try {
      const cart = await getCart();
      await updateCart(cart, true);
      const current = readState();
      writeState({
        cartToken: cart.token,
        expiresAt: current?.expiresAt > Date.now() ? current.expiresAt : Date.now() + TWO_HOURS,
      });
    } catch (error) {
      console.warn('[Perendi] Sürpriz hediye sipariş notuna eklenemedi.', error);
    } finally {
      marking = false;
    }
  };

  const inspectResult = (root) => {
    const text = root.textContent || '';
    if (ANY_REWARD_HEADING.test(text)) activateRewardWindow(root);
    if (REWARD_HEADING.test(text)) markSurpriseGift();
  };

  const attachToPopSpin = () => {
    const popup = document.querySelector('spin-wheel-popup');
    const root = popup?.shadowRoot;
    if (!root || root === observedRoot) return;
    observedRoot = root;
    inspectResult(root);
    new MutationObserver(() => inspectResult(root)).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  };

  const restoreOrExpire = async () => {
    const state = readState();
    if (!state) return;
    try {
      const cart = await getCart();
      const expired = !state.expiresAt || state.expiresAt <= Date.now();
      const differentCart = state.cartToken && state.cartToken !== cart.token;
      if (expired || differentCart) {
        if (!differentCart) await updateCart(cart, false);
        clearState();
        return;
      }
      await updateCart(cart, true);
    } catch (error) {
      console.warn('[Perendi] Sürpriz hediye sipariş notu doğrulanamadı.', error);
    }
  };

  restoreOrExpire();
  attachToPopSpin();
  new MutationObserver(attachToPopSpin).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
